// @core/api/endpoints/chat/list_thread_replies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListMessagesResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List thread replies
 * Returns all replies to a parent message in a threaded discussion. Replies are returned in chronological order.
 */
export async function ListThreadReplies(
  conversation_id: string,
  message_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListMessagesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id/thread`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.get<ListMessagesResponse>(requestPath, { ...requestOptions, params });
}
